export default __webpack_public_path__ + "static/media/remove-divider.84c58633.svg";